<template>
  <article class="dal-slider-item">
    <figure
      v-if="src"
      class="figure"
    >
      <img
        :src="src"
        draggable="false"
        class="image"
        alt=""
      />
    </figure>
    <div class="panel">
      <p><slot></slot></p>
      <DalSliderAudio
        :src="audioSrc"
        :trackTitle="trackTitle"
      ></DalSliderAudio>
    </div>
    <div
      :style="{
        'background-image': `url(${background})`
      }"
      class="background"
    ></div>
  </article>
</template>

<script>
import media from '@/utils/media'
import { mediaQueryMixin } from '@/mixins'
import DalSliderAudio from './DalSliderAudio'

export default {
  name: 'CarouselSlide',
  props: {
    srcName: {
      type: String,
      required: true
    }
  },
  mixins: [mediaQueryMixin],
  components: {
    DalSliderAudio
  },
  computed: {
    src () {
      const size = this.mobile ? 'mobile' : 'desktop'
      return media.chapter6.dalslider[this.srcName][size]
    },
    audioSrc () {
      return media.chapter6.dalslider[this.srcName].audio
    },
    background () {
      return media.chapter6.dalslider[this.srcName].background
    },
    trackTitle () {
      return `uit-het-dal${this.srcName}`
    }
  }
}
</script>

<style lang="scss" scoped>
.dal-slider-item {
  max-width: 530px;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  opacity: 0.1;
  transform: scale(0.9);
  will-change: opacity, transform;
  transition: all 1000ms ease;
  transition-property: opacity, transform;
  padding-bottom: 20px;
}
.figure {
  position: relative;
  text-align: center;
  font-size: 0;
  height: 180px;

  @media (min-width: 530px) {
    height: 300px;
  }
}
.image {
  height: 180px;
  width: 300px;
  position: relative;
  z-index: 10;

  @media (min-width: 530px) {
    height: 300px;
    width: 500px;
  }
}
.background {
  position: absolute;
  top: 0;
  bottom: 50%;
  left: -15px;
  right: -15px;
  z-index: 5;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform: scale(0);
  will-change: opacity, transform;
  transition: all 1000ms ease;
  transition-property: opacity, transform;

  @media (min-width: 530px) {
    bottom: 0%;
  }
}
.panel {
  border-radius: 10px;
  background-color: $c-dark;
  padding: 38px 24px;
  position: relative;
  z-index: 20;

  @media (min-width: 768px) {
    padding: 63px 34px;
  }
}
.is-selected {
  opacity: 1;
  transform: scale(1);

  .background {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalSliderItem.vue